import { forwardRef } from 'react';

import UiLink, { LinkProps } from '@o2/ui/Link';

/**
 * Pre-styled `@o2/ui/Link` for Footer purposes.
 */
const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
  return <UiLink color="textSecondary" underline="hover" whiteSpace="nowrap" {...props} ref={ref} />;
});

Link.displayName = 'Footer.Link';

export default Link;
